import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { TrainingsTrackerService } from '../trainings_tracker.service';

@Component({
  selector: 'app-training-actions',
  templateUrl: './training-actions.component.html',
  styleUrls: ['./training-actions.component.css']
})
export class TrainingActionsComponent {

  trainingDetails: any = {};

  readOnly = false;

  title = '';

  displayedColumns = [
    'employeeId',
    'employeeName',
    'email',
    'status',
    'actions'
  ];

  employees = [];

  filterColumns = {
    'employeeId': false,
    'employeeName': false,
    'status': false,
  };

  totalFilterOptions = {
    employeeId: [],
    employeeName: [],
    status: []
  };

  filterOptions = {
    employeeId: [],
    employeeName: [],
    status: [],
  };

  endDate: Date;

  removedEmployees = [];

  constructor(
    private dialogRef: MatDialogRef<TrainingActionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private auth: AuthServiceService,
    private service: TrainingsTrackerService,
  ) {
    this.trainingDetails = data.trainingDetails;
    this.endDate = this.trainingDetails.endDate;
    this.employees = JSON.parse(JSON.stringify(this.trainingDetails.employees));

    this.totalFilterOptions.employeeId = this.trainingDetails.employees.map((item) => {
      return {
        name: item.employeeId,
        isChecked: false,
      }
    }).filter((item, i, arr) => i === arr.findIndex((t) => t.name === item.name));

    this.totalFilterOptions.employeeName = this.trainingDetails.employees.map((item) => {
      return {
        name: item.firstName + ' ' + item.lastName,
        isChecked: false,
      }
    }).filter((item, i, arr) => i === arr.findIndex((t) => t.name === item.name));

    this.totalFilterOptions.status = this.trainingDetails.employees.map((item) => {
      return {
        name: item.status,
        isChecked: false,
      }
    }).filter((item, i, arr) => i === arr.findIndex((t) => t.name === item.name));
    
    this.filterOptions = JSON.parse(JSON.stringify(this.totalFilterOptions));
    
    this.readOnly = data.readOnly;
    this.title = this.readOnly ? 'View Training' : 'Edit Training';
  }

  onCancel() {
    this.dialogRef.close();
  }

  getEmloyeeName(row) {
    return row ? row.firstName + ' ' + row.lastName : '';
  }

  validateEndDate = (d: Date | null): boolean => {
    if (!this.trainingDetails.endDate || !d) {
      return false;
    }
  
    const startDate = new Date(this.trainingDetails.endDate);
    const twoDaysLater = new Date(startDate);
    twoDaysLater.setDate(startDate.getDate() + 2);
    return d >= startDate && d <= twoDaysLater;
  }

  removeEmployee(row) {
    this.employees = this.employees.filter((emp) => emp.employeeId !== row.employeeId);
    if (!this.removedEmployees.some((item) => item.employeeId === row.employeeId)) {
      this.removedEmployees.push(row);
    }
  }

  updateTraining() {
    if (this.readOnly) {
      if (this.employees.length === this.trainingDetails.employees.length) {
        this.callAssignTrainingsAPI();
      } else {
        this.dialogRef.close();
      }
    } else {
      this.callAssignTrainingsAPI();
    }
  }

  callAssignTrainingsAPI() {
    const params = {
      trainingId: this.trainingDetails.trainingId,
      trainingEndDate: this.endDate,
      employeeIds: this.removedEmployees
        .map((item) => item.employeeId)
        .filter(p => p)
        .join(', '),
    };
    
    this.service.updateTrainingAPI(params).subscribe(
      (res: any) => {
        this.dialogRef.close(true);
      }, (Err: any) => {
        this.dialogRef.close(false);
      }
    );
  }

  filterBasedOnSelectedOptions(column, selectedOptions) {
    if (column === 'employeeName') {
      this.employees = this.trainingDetails.employees.filter((item) => 
        selectedOptions.some((option) => option.name === item.firstName + ' ' + item.lastName) &&
        !this.removedEmployees.some((emp) => emp.employeeId === item.employeeId)
      );
    } else {
      this.employees = this.trainingDetails.employees.filter((item) => 
        selectedOptions.some((option) => option.name === item[column]) &&
        !this.removedEmployees.some((emp) => emp.employeeId === item.employeeId)
      );
    }
  }

  onOptionChange(event, option, column) {
    this.filterOptions[column].forEach((item) => {
      if (item.name === option.name) {
        item.isChecked = event;
      }
    });

    const selectedOptions = this.filterOptions[column].filter((item) => item.isChecked);
    if (selectedOptions.length > 0) {
      this.filterBasedOnSelectedOptions(column, selectedOptions);
    } else {
      this.employees = this.trainingDetails.employees.filter((item) =>
        !this.removedEmployees.some((emp) => emp.employeeId === item.employeeId)
      );
    }
  }

  openCloseFilter(column) {
    Object.keys(this.filterColumns).forEach(key => {
      if (key !== column) {
        this.filterColumns[key] = false;
      }
    });
    this.filterColumns[column] = !this.filterColumns[column];
  }

  searchOptions(value, column) {
    if (value) {
      this.filterOptions[column] = this.totalFilterOptions[column].filter((item) => {
        return column === 'employeeId'
          ? `${item.name}`.toLowerCase().startsWith(value.toLowerCase())
          : item.name.toLowerCase().includes(value.toLowerCase());
      });
    } else {
      this.filterOptions[column] = this.totalFilterOptions[column];
    }
  }
}
